import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { getTransactions, getWalletBalance } from '../api/transactionsApi';
import useAuth from '@/context/auth/useAuth';

function useTransactions({ fetchTransactionsList = false, fetchWalletBalance = false } = {}) {
    const { userIsLoggedIn } = useAuth();

    const {
        data: transactionsData,
        isFetching: transactionsDataIsFetching,
        isFetchingNextPage: transactionsDataIsFetchingNextPage,
        fetchNextPage: transactionsDataFetchNextPage
    } = useInfiniteQuery({
        queryKey: ['getTransactions'],
        queryFn: (input) => {
            return getTransactions({ next: input?.pageParam });
        },
        getNextPageParam: (lastPage) => {
            return lastPage?.links?.next || undefined;
        },
        staleTime: 30 * 60 * 1000,
        enabled: fetchTransactionsList && userIsLoggedIn
    });

    const {
        isLoading: walletBalanceLoading,
        data: walletBalance,
        error: walletBalanceError
    } = useQuery({
        queryKey: ['getWalletBalance'],
        queryFn: getWalletBalance,
        enabled: fetchWalletBalance && userIsLoggedIn,
        staleTime: Infinity,
        gcTime: Infinity
    });

    return {
        transactionsData,
        transactionsDataIsFetching,
        transactionsDataIsFetchingNextPage,
        transactionsDataFetchNextPage,
        walletBalanceLoading,
        walletBalance,
        walletBalanceError
    };
}

export default useTransactions;
